import { getCreditShortfall } from '../utils/creditGate';

import { eventService } from './eventService';

/** Use the same warning/toaster path as backend insufficient-credit events. */
export const signalInsufficientCredits = (shortfall?: number): void => {
  const normalizedShortfall = getCreditShortfall({ shortfall }) ?? 1;

  eventService.emit('insufficient_credits', {
    required: normalizedShortfall,
    shortfall: normalizedShortfall,
  });
  window.dispatchEvent(new Event('insufficient_credits_blocked'));
};
